export const selectCommodityDetailedState = (state) =>
  state.commoditySamplingDetailed || {};

export const selectCommodityTableData = (state) =>
  selectCommodityDetailedState(state).tableData || [];

export const selectCommodityTotal = (state) =>
  selectCommodityDetailedState(state).totalCommodities || 0;

export const selectCommodityLoading = (state) =>
  selectCommodityDetailedState(state).loading || false;

export const selectCommodityError = (state) =>
  selectCommodityDetailedState(state).error;

export const selectCommodityPagination = (state) =>
  selectCommodityDetailedState(state).pagination || { currentPage: 1, pageSize: 10, total: 0 };

export const selectCommodityCurrentPage = (state) =>
  selectCommodityDetailedState(state).pagination?.currentPage || 1;

export const selectCommodityPageSize = (state) =>
  selectCommodityDetailedState(state).pagination?.pageSize || 10;